import React, { useEffect, useState } from "react";
import SecondaryMenu from "../shared/SecondaryMenu";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import "../../style/UserStyleSheet.css";
import LinearProgress from "@material-ui/core/LinearProgress";
import { useHistory } from "react-router-dom";
import { IconButton, TextField } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import api from "../../store/api";

interface IReasonsForReschedule {
  reasonForRescheduleId: string;
  name: string;
  cause: string;
}

const headCells = [
  {
    id: "reason",
    numeric: false,
    disablePadding: false,
    label: "Reason",
    width: "40%",
  },
  {
    id: "cause",
    numeric: false,
    disablePadding: false,
    label: "Cause",
    width: "60%",
  },
];

const ViewReasonsForRescheduleWidget = (): JSX.Element => {
  const history = useHistory();
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [reasonsList, setReasonsList] = useState<IReasonsForReschedule[]>([]);
  const [recordCount, setRecordCount] = useState(0);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("ModifiedOn");
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const PAGE_SIZE = 10;

  const GetReasonForRescheduleonSearch = async (searchText:any) => {
    try {
      setLoading(true);
      const request = {
        searchStr:searchText,
        pageNumber: String(page + 1),
        pageSize: String(PAGE_SIZE),
        sortColumn: orderBy,
        sortDirection: order,
      }

      const _res = await api.getReasonForRescheduleSearch("",request);
      if (_res !== null && _res.model !== null && !_res.errorRaised && _res.model !== null) {
        const data = _res?.model;
        setReasonsList(data);
        setRecordCount(_res?.itemsCount ?? 0);
        setLoading(false);
      }
    }
    catch (error) {
      setLoading(false);
      console.log(error)
    }
  };

  useEffect(() => {
    GetReasonForRescheduleonSearch(searchText);
  }, [page,page,orderBy,order]);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      GetReasonForRescheduleonSearch(searchText);
    }, 3000);
  }, [searchText]);


  const createSortHandler = (column: any) => {
    let order_str = "asc";
    // if (orderBy === column) {
      if (order === "asc") {
        order_str = "desc";
      }
    // }
    setOrder(order_str);
    setOrderBy(orderBy);
  };

  const handleChangePage = (_event: any, newPage: any) => {
    setPage(newPage);
  };

  const inputChangedHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchText(value);
    search(value);
  };

  const search = async (keyword: string): Promise<void> => {
    setPage(0);
  };

  const searchByEnter = async (event: any): Promise<void> => {
    if (event.key === "Enter") {
      await search(searchText);
    }
  };

  const handleAdd = () => {
    history.push({
      pathname: "/settings/rescheduleReasons/add",
    });
  };
  const handleEdit = (id: any) => {
    if (id) {
      history.push({
        pathname: "/settings/rescheduleReasons/edit/" + id,
      });
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
      <div style={{ alignSelf: "stretch", display: "flex" }}>
        <SecondaryMenu selectedmenu="Reasons For Reschedule" />
      </div>
      <div style={{ display: "flex", alignSelf: "start", width: "100%" }}>
        <Grid
          container
          style={loading ? { pointerEvents: "none", opacity: "0.4" } : {}}
        >
          {loading ? <CreateLoadingLine /> : null}
          <Grid item xs={6} style={{ paddingLeft: 40 }}>
            <div className={classes.heading}>Reasons For Reschedule</div>
            
          </Grid>
          <Grid
            item
            container
            xs={6}
            justify="flex-end"
            style={{ paddingRight: 25, paddingTop: 40, paddingBottom: 40 }}
          >
            <div style={{ display: "flex" }}>
              <TextField
                classes={{ root: classes.searchTextBox }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon style={{ color: "#707070" }} />
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
                className="searchTxt"
                id="standard-adornment-password"
                type="text"
                onKeyUp={searchByEnter}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  inputChangedHandler(e)
                }
              />

              <Button
                variant="contained"
                color="primary"
                className="searchBtn"
                style={{ marginLeft: 20 }}
                onClick={handleAdd}
              >
                Add Reason
              </Button>
            </div>
          </Grid>

          {/* <Grid container item xs={12} justifyContent="flex-end"> */}
          <Grid container item xs={12} justify="flex-end">
            <TableContainer>
              <Table className={classes.table} size={"medium"}>
                <TableHead>
                  <TableRow>
                    {headCells.map((headCell) => (
                      <TableCell
                        key={headCell.id}
                        className={classes.tableHeading}
                        width={headCell.width}
                        align={headCell.numeric ? "right" : "left"}
                        padding={headCell.disablePadding ? "none" : "default"}
                      >
                        {headCell.id ? headCell.label : null}
                        {headCell.id === "reason" && (
                          <>
                            {" "}
                            <IconButton
                              classes={{ root: classes.buttonRoot }}
                              onClick={() => createSortHandler(headCell.id)}
                            >
                              <KeyboardArrowDownIcon
                                style={{
                                  padding: 0,
                                  marginBottom: 0,
                                  ...(orderBy === headCell.id
                                    ? order === "asc"
                                      ? {}
                                      : { transform: "rotate(180deg)" }
                                    : {}),
                                }}
                              />
                            </IconButton>
                          </>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {reasonsList.length > 0 ? (
                    reasonsList.map((row, index) => {
                      return (
                        <TableRow
                          key={row.reasonForRescheduleId}
                          className={classes.tableRow}
                          tabIndex={-1}
                          hover
                          onClick={() => handleEdit(row.reasonForRescheduleId)}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            padding="default"
                          >
                            {row.name}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            padding="default"
                          >
                            {row.cause ? "Customer" : "Non-Customer"}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={5}>
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              rowsPerPageOptions={[10]}
              count={recordCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
            />
          </Grid>
        </Grid>
      </div>
      
    </div>
  );
};

export default React.memo(ViewReasonsForRescheduleWidget);

const CreateLoadingLine = (props: any): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.loading}>
      <LinearProgress color="primary" />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    //padding: theme.spacing(0, 0, 0, 35),
    paddingLeft: 40,
    paddingRight: 40,
  },
  heading: {
    fontSize: 36,
    fontWeight: 900,
    padding: theme.spacing(5, 0, 5, 0),
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "25ch",
    backgroundColor: "#ECECEC",
    height: 30,
  },
  formBtn: {
    width: "100px",
  },
  gridStyle: {
    padding: theme.spacing(5, 0, 5, 0),
  },
  table: {},
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  loading: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2, 0, 0, 50),
    },
  },
  searchTextBox: {
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: 0,
      top: 4,
    },
    height: 44,
  },
  textFieldInput: {
    backgroundColor: "#ECECEC",
    color: "black",
    height: "44px",
    border: "none",
    display: "flex",
    flexDirection: "row-reverse",
  },
  tableRow: {
    cursor: "pointer",
  },
  tableHeading: {
    fontWeight: "bold",
  },
  buttonRoot: {
    padding: 0,
  },
}));
